/**
 * Router minimal basé sur le hash (#/)
 */

const routes = new Map();
let currentRoute = null;

/**
 * Enregistre une route
 * @param {string} path - Chemin de la route (ex: '/', '/services')
 * @param {Function} handler - Fonction à exécuter
 */
export function registerRoute(path, handler) {
  routes.set(path, handler);
}

/**
 * Récupère le chemin actuel depuis le hash
 * @returns {string}
 */
export function getCurrentPath() {
  let hash = window.location.hash.slice(1) || '/';
  
  // Si le hash commence directement par des paramètres Supabase (pas de route)
  // Exemple: #access_token=... ou #error=...
  if (hash.startsWith('access_token=') || 
      hash.startsWith('error=') || 
      hash.startsWith('type=') ||
      hash.startsWith('refresh_token=')) {
    console.warn('🔑 Tokens/erreurs Supabase détectés dans l\'URL, route: /auth/callback');
    return '/auth/callback';
  }
  
  // Nettoyer les fragments de tokens Supabase après un # supplémentaire
  // Exemple: #/account#access_token=...
  if (hash.includes('#')) {
    hash = hash.split('#')[0];
  }
  
  // Nettoyer les query params de tokens si présents
  // Exemple: #/account?access_token=...
  if (hash.includes('?access_token') || hash.includes('&access_token')) {
    hash = hash.split('?')[0].split('&')[0];
  }

  // IMPORTANT: Retirer toute query string générique pour la résolution de route
  // Exemple: #/login?redirect=/admin -> '/login'
  if (hash.includes('?')) {
    hash = hash.split('?')[0];
  }
  
  return hash || '/';
}

/**
 * Navigue vers un chemin
 * @param {string} path - Chemin de destination
 * @param {object} [state] - État à passer
 */
export function navigateTo(path, state = {}) {
  window.location.hash = path;
  if (state) {
    window.history.replaceState(state, '', window.location.href);
  }
}

/**
 * Gère le changement de route
 */
function handleRouteChange() {
  const path = getCurrentPath();

  // Chercher la route correspondante
  const handler = routes.get(path);

  if (handler) {
    currentRoute = path;
    handler(path);
  } else {
    // Route 404 - rediriger vers home
    console.warn(`Route non trouvée: ${path}`);
    navigateTo('/');
  }
}

/**
 * Initialise le router
 */
export function initRouter() {
  // Écouter les changements de hash
  window.addEventListener('hashchange', handleRouteChange);

  // Gérer la route initiale
  handleRouteChange();
}

/**
 * Nettoie le router (pour les tests)
 */
export function cleanupRouter() {
  window.removeEventListener('hashchange', handleRouteChange);
  routes.clear();
  currentRoute = null;
}

/**
 * Récupère la route actuelle
 * @returns {string}
 */
export function getRoute() {
  return currentRoute;
}
